<template>
  <v-dialog modal :value="!APIHUB_authenticated" width="350px" persistent>
    <v-card class="elevation-12">
      <v-toolbar dark color="primary">
        <v-toolbar-title>Login</v-toolbar-title>
      </v-toolbar>
      <v-progress-linear indeterminate v-if="authenticating" />
      <v-card-text>
        <v-alert color="error" :value="msg.length > 0">{{ msg }}</v-alert>
        <v-form @submit.prevent="login">
          <v-text-field
            v-model="username"
            prepend-icon="person"
            name="Username"
            placeholder="Username"
            :disabled="authenticating"
          ></v-text-field>
          <v-text-field
            v-model="password"
            name="Password"
            id="password"
            prepend-icon="lock"
            placeholder="Password"
            type="password"
            :disabled="authenticating"
          ></v-text-field>
          <v-btn type="submit" color="primary" :disabled="authenticating">
            Login
          </v-btn>
        </v-form>

        <v-btn tag="a" :href="ms_auth_url" v-if="ms_auth_url">
          Sign in with Microsoft <v-icon>mdi-ms</v-icon>
        </v-btn>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import { AUTHENTICATE } from "@/store/actions";
// import { authContext } from "../ms-ad-auth";

export default {
  name: "authDialog",
  data() {
    return {
      username: "",
      password: "",
      ms_auth_url: ""
    };
  },
  methods: {
    async login() {
      this.msg = "";
      const { username, password } = this;

      try {
        await this.$store.dispatch(AUTHENTICATE, { username, password });
      } catch (e) {
        this.msg = e.message;
      }
    }
    // msLogin() {
    //   var user = authContext.getCachedUser();
    //   if (user) {
    //     console.log(user);
    //   } else {
    //     authContext.login();
    //   }
    // }
    // authenticating {
    //   return this.$store.state.auth.status == "authenticating";
    // },
    // error() {
    //   return this.$store.state.auth.status == "error";
    // }
  },
  computed: {
    ...mapState({
      APIHUB_authenticated: state => state.auth.authenticated,
      authenticating: state => state.auth.status == "authenticating",
      error: state => state.auth.status == "error"
    })
  },
  props: {
    msg: {
      type: String,
      default: ""
    }
  },
  async created() {
    try {
      let authUrl = await this.$http.get("auth/getUrl", {
        params: { redirect_to: window.location.href }
      });
      if (authUrl.data) {
        authUrl = authUrl.data;
        // authUrl = new URL(authUrl);
        // console.debug("authUrl: ", authUrl);
        // authUrl.searchParams["state"] = window.location.href;
        this.ms_auth_url = authUrl;
      }
    } catch (e) {
      console.error(e);
    }
  }
};
</script>
